import { createSelector, MemoizedSelector } from '@ngrx/store';
import { MultiContractData } from '@app/services/signal-r/model/multicontract-data';
import { getMultiContractDataState } from '@app/store/faxe/faxe-selectors';
import { selectAllMultiContractData } from '@app/store/faxe/multi-contract/multi-contract-reducer';

export const selectMultiContractDataAll: MemoizedSelector<object, MultiContractData[]> = createSelector(
  getMultiContractDataState,
  selectAllMultiContractData
);

export const selectMultiContractDataState =
  ():
    MemoizedSelector<object, { multiContractData: MultiContractData[] }> =>
    createSelector(
      getMultiContractDataState,
      selectMultiContractDataAll,
      (state, all) => ({
        multiContractData: all
      })
    );

export const selectMultiContractDataSateAll= ():
    MemoizedSelector<object, MultiContractData[]> =>
    createSelector(
      getMultiContractDataState,
      selectMultiContractDataAll,
      (state, all) =>
        all
    );

export const selectMultiContractDataByVersion =
  (dataType: string, version: number):
    MemoizedSelector<object, MultiContractData[]> =>
    createSelector(
      getMultiContractDataState,
      selectMultiContractDataAll,
      (state, all) =>
        all
          .filter(multiContractData =>
            multiContractData.multiContract.dataType === dataType && multiContractData.multiContract.version === version)
    );

